module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-three-smc/key-1-2015.svg?v=a9399db5";